import { MenuItem as MuiMenuItem, Popper } from '@mui/material';
import styled from 'styled-components';

export const StyledPopover = styled(Popper)`
  background-color: ${({ theme }) => theme.palette.common.white};
  box-shadow: none;
  border: none;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
  padding: 8px 0;
  box-shadow: ${({ theme }) => theme.shadows.card};
`;

export const MenuItem = styled(MuiMenuItem)`
  width: 120px;
  font-size: 14px;
  justify-content: space-between;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.common.white};
  height: 36px;
  padding: 6px 16px;
  :hover {
    background-color: ${({ theme }) => theme.palette.common.white};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
  button {
    margin-left: 1rem;
  }
`;

export const MainInformation = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.common.white};
  display: flex;
  padding: 20px;
  flex-direction: row;
  justify-content: space-between;
  gap: 15px;
  align-self: stretch;
  margin-top: 20px;
  font-size: 16px;
  h1 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 14px;
    font-weight: 600;
    line-height: 143%; /* 20.02px */
    letter-spacing: 0.17px;
    margin: 0;
    margin-bottom: 6px;
  }
  p {
    color: ${({ theme }) => theme.palette.text.primary};
    font-weight: 400;
    letter-spacing: 0.15px;
    margin: 0;
  }
`;

export const TasksLabel = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
`;

export const TasksContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const TasksIconContainer = styled.div`
  position: relative;
  height: 16px;
  width: 16px;
`;
